module.exports = __webpack_public_path__ + "img/brand-1.da4667e4.jpg";